import { ComponentPropsWithoutRef } from 'react';
import { TextPart } from '@tanstack/ai-react/ui';

import './MarkdownPart.scss';

type Props = {
  content: string;
};

const HTTPS_URL = /^https:\/\//i;

export const MarkdownLink = ({ children, href }: ComponentPropsWithoutRef<'a'>) =>
  HTTPS_URL.test(href ?? '') ? (
    <a href={href} rel="noopener noreferrer" target="_blank">
      {children}
    </a>
  ) : (
    <span>{children}</span>
  );

const NoImage = () => null;

const MARKDOWN_COMPONENTS = { a: MarkdownLink, img: NoImage };

export const MarkdownPart = ({ content }: Props) =>
  content.trim() ? <TextPart className="markdown-part" components={MARKDOWN_COMPONENTS} content={content} /> : null;
